export const projectionUniforms = `
    // Brown Conrady and fisheye
    uniform vec4 k;

    // Brown Conrady
    uniform vec2 p;

    // LUT
    struct LutMetadata {
        float alpha_max;
        float alpha_min;
        float alpha_step;
        float phi_max;
        float phi_min;
        float phi_step;
        float image_width;
        float image_height;
    };

    uniform sampler2D lut;
    uniform LutMetadata lutMetadata;
    uniform mat4 inverseCalibrationMatrix;

    // LUT, cylindrical and deformed cylinder
    uniform vec3 cameraWorldDirection;
    uniform vec3 cameraWorldPosition;

    // motion compensation
    uniform vec3 offset;
    uniform sampler2D compensatedCuboids;
    uniform int compensatedCuboidCount;
`;
